/**
 * GT Social proof — demo-style Swiper (loop, centered, navigation, curved masks via CSS).
 */
(function () {
  'use strict';

  /**
   * @param {HTMLElement} root
   */
  function initSocialProof(root) {
    if (!root || typeof window.Swiper !== 'function') return;

    var el = root.querySelector('.gt-social-proof__swiper');
    if (!el) return;

    if (el.swiper) {
      el.swiper.destroy(true, true);
    }

    var gap = parseInt(String(root.dataset.slideGap || '20'), 10);
    if (Number.isNaN(gap) || gap < 0) gap = 20;

    var nextEl = el.querySelector('.swiper-button-next');
    var prevEl = el.querySelector('.swiper-button-prev');

    /** @type Record<string, unknown> */
    var params = {
      loop: true,
      centeredSlides: true,
      // Mobile: show one focused center slide and half-peek neighbors.
      slidesPerView: 2,
      spaceBetween: Math.max(8, Math.min(gap, 14)),
      grabCursor: true,
      observer: true,
      observeParents: true,
      watchSlidesProgress: true,
      speed: 600,
      navigation:
        nextEl && prevEl
          ? {
              nextEl: nextEl,
              prevEl: prevEl,
            }
          : false,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
      breakpoints: {
        480: {
          slidesPerView: 2,
          spaceBetween: Math.max(10, Math.min(gap, 18)),
        },
        750: {
          slidesPerView: 3,
          spaceBetween: gap,
        },
        1100: {
          slidesPerView: 5,
          centeredSlides: false,
          spaceBetween: gap,
        },
      },
    };

    try {
      el.style.removeProperty('--swiper-wrapper-transition-timing-function');
    } catch (_) {
      /**/
    }

    // eslint-disable-next-line no-undef
    new Swiper(el, params);
  }

  function initAll() {
    document.querySelectorAll('[data-gt-social-proof]').forEach(initSocialProof);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (ev) {
    var target = ev.target;
    if (!target || !target.querySelector) return;
    var wrap = target.querySelector('[data-gt-social-proof]');
    if (wrap) initSocialProof(wrap);
  });

  document.addEventListener('shopify:section:unload', function (ev) {
    var target = ev.target;
    if (!target || !target.querySelector) return;
    var swEl = target.querySelector('.gt-social-proof__swiper');
    if (swEl && swEl.swiper) {
      swEl.swiper.destroy(true, true);
    }
  });
})();
